module.exports = __webpack_public_path__ + "media/images/logo__stingergc-c885703e057f0b9db6d0f4990bd64356.png";